module.exports = __webpack_public_path__ + "img/company_logo.422c6e91.png";